import { StepperSize, StepperSizeConfig } from './types.ts';

export const STEPPER_SIZE_CONFIG: Record<StepperSize, StepperSizeConfig> = {
  xs: {
    circleSize: 20,
    progressBarWidth: 2,
    titleFontSize: 12,
    substepFontSize: 10,
    gap: 8,
  },
  sm: {
    circleSize: 24,
    progressBarWidth: 3,
    titleFontSize: 14,
    substepFontSize: 11,
    gap: 12,
  },
  md: {
    circleSize: 30,
    progressBarWidth: 4,
    titleFontSize: 16,
    substepFontSize: 13,
    gap: 16,
  },
  lg: {
    circleSize: 36,
    progressBarWidth: 5,
    titleFontSize: 18,
    substepFontSize: 15,
    gap: 20,
  },
  xl: {
    circleSize: 42,
    progressBarWidth: 6,
    titleFontSize: 20,
    substepFontSize: 17,
    gap: 24,
  },
  xxl: {
    circleSize: 48,
    progressBarWidth: 7,
    titleFontSize: 22,
    substepFontSize: 19,
    gap: 28,
  },
};

export const getStepperSizeConfig = (size: StepperSize = 'md'): StepperSizeConfig => {
  return STEPPER_SIZE_CONFIG[size];
};